import * as types from './constants';

// Get Members
export const getMembersRequest = data => (
  { type: types.GET_MEMBERS_REQUEST, payload: data }
);

export const getMembersDone = data => (
  { type: types.GET_MEMBERS_DONE, payload: data }
);

export const getMembersFailed = errors => (
  { type: types.GET_MEMBERS_FAILED, payload: errors }
);

// Delete Member
export const deleteMemberRequest = data => (
  { type: types.DELETE_MEMBER_REQUEST, payload: data }
);

export const deleteMemberDone = () => (
  { type: types.DELETE_MEMBER_DONE }
);

export const deleteMemberFailed = errors => (
  { type: types.DELETE_MEMBER_FAILED, payload: errors }
);

export const deleteMemberReset = () => (
  { type: types.DELETE_MEMBER_RESET }
);

// Operations
export const membersSetPage = data => (
  { type: types.MEMBERS_SET_PAGE, payload: data }
);